import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, SMALL_MARGIN, MIDDLE_MARGIN } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      [theme.breakpoints.down('sm')]: {
        padding: '0 24px',
      },
    },
    title: {
      [theme.breakpoints.down('sm')]: {
        border: 'none',
      },
    },
    row: {
      color: colorsPalette.gray,
      '&:first-child': {
        marginBottom: MIDDLE_MARGIN,
        [theme.breakpoints.down('sm')]: {
          marginTop: SMALL_MARGIN,
        },
      },
    },
    rowTitle: {
      fontSize: 18,
      lineHeight: 1.2,
      fontWeight: 700,
      color: colorsPalette.white,
    },
    rowInfo: {
      marginTop: SMALL_MARGIN,
      fontSize: 18,
      lineHeight: 1.5,
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
    },
  }),
);

export default useStyles;
